import VueBase from 'vue';
import VueAdal from '@/vue-adal';
import SnackBarInterface from './shared/snackbar/snackbar.interface';

export default class Vue extends VueBase {
  public $adal!: VueAdal;

  public $snackbar!: SnackBarInterface;
}
